import { IntlShape } from 'react-intl'
import { Item } from 'typings'
import { create, enforce, test } from 'vest'
import { AudienceForm } from './AudienceEditor'
import { messages } from './messages'

export function suite(intl: IntlShape, name: string) {
  return create((config: AudienceForm) => {
    const { $t } = intl
    const { validation } = messages
    const { audiences } = config

    test(name, $t(validation.required), () => {
      enforce(audiences.length).greaterThan(0)
    })
  })
}

export function sectionSuite(intl: IntlShape, name: string) {
  return create((audiences: Item[] | undefined) => {
    const { $t } = intl
    const { validation } = messages

    test(name, $t(validation.addRequired), () => {
      enforce(audiences).isNotUndefined()
    })
  })
}
